import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface ApplicationTrackingUIState {
  activeTab: number;
  // We store page index per tab. Index is the tab index.
  tabPages: number[];
  // We store page size per tab. Index is the tab index.
  tabPageSizes: number[];
}

const initialState: ApplicationTrackingUIState = {
  activeTab: 0,
  // Initialize with 0 for 6 tabs (as per original file)
  tabPages: [0, 0, 0, 0, 0, 0],
  // Initialize with 10 for 6 tabs
  tabPageSizes: [10, 10, 10, 10, 10, 10],
};

export const applicationTrackingUISlice = createSlice({
  name: 'applicationTrackingUI',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<number>) => {
      state.activeTab = action.payload;
    },
    setPageForTab: (state, action: PayloadAction<{ tabIndex: number; page: number }>) => {
      const { tabIndex, page } = action.payload;
      if (state.tabPages[tabIndex] !== undefined) {
        state.tabPages[tabIndex] = page;
      }
    },
    setPageSizeForTab: (state, action: PayloadAction<{ tabIndex: number; pageSize: number }>) => {
      const { tabIndex, pageSize } = action.payload;
      if (state.tabPageSizes[tabIndex] !== undefined) {
        state.tabPageSizes[tabIndex] = pageSize;
      }
    },
    resetApplicationTrackingUI: (state) => {
      state.activeTab = initialState.activeTab;
      state.tabPages = initialState.tabPages;
      state.tabPageSizes = initialState.tabPageSizes;
    },
  },
});

export const { setActiveTab, setPageForTab, setPageSizeForTab, resetApplicationTrackingUI } =
  applicationTrackingUISlice.actions;

export const selectActiveTab = (state: RootState) => state.applicationTrackingUI.activeTab;
export const selectTabPages = (state: RootState) => state.applicationTrackingUI.tabPages;
export const selectTabPageSizes = (state: RootState) => state.applicationTrackingUI.tabPageSizes;

export default applicationTrackingUISlice.reducer;
